export const POLITICIAN_NAMES = [
  '馬英九',
  '蔡英文',
  '賴清德',
  '韓國瑜',
  '柯文哲',
  '傅崐萁',
  '黃國昌',
  '鄭麗文',
];
